import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from '@wix/yoshi-flow-editor';
import focus from '@wix/wix-vod-shared/dist/esm/widget/utils/accessibility-focus';

import CloseButton from '@wix/wix-vod-shared/dist/esm/widget/ui-components/close-button/close-button';

import { getChannelForWidget } from '@wix/wix-vod-shared/common';

import ChannelInfoContent from '../../../components/channel-actions/channel-info-content/channel-info-content';

import styles from './channel-info-view.scss';

const mapStateToProps = (state) => ({
  channelData: getChannelForWidget(state),
});

export default withTranslation()(
  connect(mapStateToProps)(
    class ChannelInfoView extends React.Component {
      static propTypes = {
        channelData: PropTypes.object,
        close: PropTypes.func,
      };

      componentDidMount() {
        focus(this.containerRef);
      }

      saveContainerRef = (ref) => {
        this.containerRef = ref;
      };

      handleCloseButtonClick = () => {
        this.props.close();
      };

      render() {
        const { channelData } = this.props;

        return (
          <section
            className={styles.window}
            role="dialog"
            aria-label={this.props.t(
              'widget.compact-view.components.action-bar.channel-info-tooltip',
            )}
            aria-describedby="widget-channel-info"
            ref={this.saveContainerRef}
          >
            <div className={styles.content}>
              <ChannelInfoContent channelData={channelData} />
              <CloseButton
                className={styles['close-button']}
                onClick={this.handleCloseButtonClick}
                theme="dark"
                ariaLabel={this.props.t(
                  'widget.accessibility.close-channel-info',
                )}
              />
            </div>
          </section>
        );
      }
    },
  ),
);
